import { Spinner } from "@blueprintjs/core";
import { observer } from "mobx-react";
import { DetailsPopup } from "modules/common/components/form/DetailsPopup";
import { EMPTY_OBJECT_ID } from "modules/common/constants";
import { useMst } from "modules/root/models/hooks";
import { can } from "modules/session/auth/access";
import func from "modules/spending/functionalities";
import React, { useEffect, useState } from "react";
import { EmployeePositionDetails } from "./EmployeePositionDetails";

interface PositionDialogProps {
    /** пусто — новая должность */
    positionId: string;
    onClose(): void;
    /** id сохранённой должности */
    onSaved(id: string): void;
}

/**
 * Форма «Должность» поверх карточки сотрудника или дерева структуры — та же, что в справочнике
 * должностей. Должность — справочник «кем работает»; подразделение сотрудника задаётся отдельно.
 */
export const PositionDialog = observer(({ positionId, onClose, onSaved }: PositionDialogProps) => {
    const { employeePositions, session } = useMst();
    const [ready, setReady] = useState(false);
    const id = positionId || EMPTY_OBJECT_ID;

    useEffect(() => {
        let alive = true;
        setReady(false);
        Promise.all([employeePositions.details.load(id), employeePositions.departments.load()])
            .catch(() => undefined)
            .finally(() => alive && setReady(true));
        return () => {
            alive = false;
        };
    }, [employeePositions, id]);

    return (
        <DetailsPopup title="Должность" onCancel={onClose}>
            {ready ? (
                <EmployeePositionDetails
                    manualFile={employeePositions.details.manualFile}
                    canChange={can(func.DEPARTMENT_EDIT, session.access)}
                    employeePosition={employeePositions.details}
                    onSaved={() => onSaved(employeePositions.details.id)}
                    onRemoved={onClose}
                    departments={employeePositions.departments}
                    department=""
                    baseUrl={session.baseUrl}
                />
            ) : (
                <div style={{ padding: 60, display: "grid", placeItems: "center" }}>
                    <Spinner size={32} />
                </div>
            )}
        </DetailsPopup>
    );
});
